<template>
  <div class="modal-successfully-sent">
    <button @click.prevent="onClose"
            class="modal-successfully-sent__close">
      <BaseSvg name="ico-close"/>
    </button>
    <img src="@/assets/img/modal-successfully-sent.svg"
         alt="message"
         class="modal-successfully-sent__img">
    <div v-if="title"
         class="modal-successfully-sent__text text">
      <p><b>{{title}}</b></p>
    </div>
    <div v-if="text"
         v-html="text"
         class="modal-successfully-sent__text text"></div>
    <div class="modal-successfully-sent__footer">
      <button @click.prevent="onClose"
              class="modal-successfully-sent__btn  base-btn  base-btn--green">
        {{ $tGlobal('modal-successfully-sent-button') }}
      </button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ModalCallBackSent',
    props: {
      modalName: {
        type: String,
        required: true
      },
      title: String,
      text: String,
    },
    data() {
      return {}
    },
    methods: {
      onClose() {
        this.$vModal.close(this.modalName)
      }
    }
  }
</script>

<style lang="less">

</style>
